import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from "react";
import classes from "../KeywordsMergingDisplay/KeywordsMergingDisplay.module.css";
import styles from "../Merging.module.css";
import DroppableList from "../DraggingWrappers/DroppableList";
import {useSelector} from "react-redux";
import axios from "axios";
import apiUrl from "../../../shared/config";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";

const GroupsMergingDisplay = forwardRef(({fromPattern, toPattern, patternSelected}, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const userId = useSelector(state => state.auth.userId)
    const token = useSelector(state => state.auth.token)
    const [userGroupMemberships, setUserGroupMemberships] = useState([])
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.group &&
            toList.some(f => +item.group.group_id === +f.group.group_id)
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.group &&
            fromList.some(f => +item.group.group_id === +f.group.group_id)
        );
    }, [fromList]);

    const isPartOfGroup = useCallback( (item) => {
        return userGroupMemberships.some(g => +g === +item.group.group_id)
    }, [userGroupMemberships])


    useEffect(() => {
        if (fromPattern && fromPattern.groups) {
            const updatedFromList = fromPattern.groups.map((group) => {
                const id = group.group_id + " pattern_id-" + fromPattern.pattern_id;
                const isGrayedOut = true;
                return {
                    id,
                    group,
                    content: (
                        <div
                            key={id}
                            className={`${classes.Keyword} clickable ${isGrayedOut ? classes.GrayedOut : ''}`}
                            onClick={() => {}}
                        >
                            {group.group_name}
                        </div>
                    ),
                    disableDrag: true
                };
            });
            setFromList(updatedFromList);
        }
    }, [fromPattern, patternSelected]);

    useEffect(() => {
        if (toPattern && toPattern.groups && fromPattern && fromPattern.groups) {
            const bothList = toPattern && fromPattern ? [...toPattern.groups, ...fromPattern.groups] : [];

            const uniqueList = bothList.filter((item, index, self) =>
                index === self.findIndex((i) => i.group_id === item.group_id)
            );

            const updatedToList = uniqueList.map((group) => {
                const id = group.group_id + " pattern_id-" + toPattern.pattern_id;
                const noDrag = (!isPartOfGroup({group}) && fromPattern.groups.some(i => i.group_id === group.group_id))
                    || toPattern.groups.some(i => i.group_id === group.group_id);

                return {
                    id,
                    group,
                    content: (
                        <div
                            key={id}
                            className={`${noDrag ? classes.ToKeyWord : classes.Keyword} clickable`}
                            onClick={() => {}}
                        >
                            {group.group_name}
                        </div>
                    ),
                    disableDrag: noDrag
                };
            });
            setToList(updatedToList);
        }
    }, [toPattern, fromPattern, patternSelected, isPartOfGroup]);

    useEffect(() => {
        if (Number.isInteger(+userId) && token) {
            axios.get(apiUrl + 'Users/getUserById?user_id=' + userId + '&token=' + token)
                .then(response => {
                    setUserGroupMemberships(response.data.groups.map(group => group.group_id))
                })
        }
    }, [userId, token]);

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === 'toList' && destination === 'fromList' && isPartOfGroup(item) && existsInFromList(item)) {
            let newItem = {...item}
            newItem.content = <div
                key={newItem.id}
                className={`${classes.Keyword} clickable`}
                onClick={() => {
                }}
            >
                {newItem.group.group_name}
            </div>

            setFromList(prev => [...prev.filter(i => i.group.group_id !== newItem.group.group_id), newItem])
            setToList(prev => [...prev.filter(i => i.group.group_id !== newItem.group.group_id)])
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            let newItem = {...item}
            let isGrayedOut = !isPartOfGroup(item) && existsInFromList(item)
            newItem.content = <div
                key={newItem.id}
                className={`${classes.Keyword} clickable ${isGrayedOut ? classes.GrayedOut : ''}`}
                onClick={() => {
                }}
            >
                {newItem.group.group_name}
            </div>
            newItem.disableDrag = isGrayedOut;

            setToList(prev => [newItem, ...prev]); // Add to target
            let newOldItem = {...item}
            newOldItem.content = <div
                key={newItem.id}
                className={`${classes.Keyword} clickable ${classes.GrayedOut}`}
                onClick={() => {
                }}
            >
                {newItem.group.group_name}
            </div>
            newOldItem.disableDrag = true;

            setFromList(prev => [...prev.filter(i => i.group.group_id !== newItem.group.group_id), newOldItem])
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.group);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            <div className={styles.SplitCols}>
                <h3>Groups:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'GROUPS'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols}>
                <h3>Groups:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'GROUPS'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});


export default GroupsMergingDisplay